import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from './components/Layout';
import ReviewGate from './components/ReviewGate';
import VisitTracker from './components/VisitTracker';
import Home from './pages/Home';
import PrivateExperiences from './pages/PrivateExperiences';
import SignatureJourneys from './pages/SignatureJourneys';
import Corporate from './pages/Corporate';
import Gift from './pages/Gift';
import About from './pages/About';
import Enquire from './pages/Enquire';
import Admin from './pages/Admin';

// Admin lives outside ReviewGate + Layout (no public header/footer wrapping it).
function PublicShell() {
  return (
    <ReviewGate>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/private-experiences" element={<PrivateExperiences />} />
          <Route path="/signature-journeys" element={<SignatureJourneys />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/gift" element={<Gift />} />
          <Route path="/about" element={<About />} />
          <Route path="/enquire" element={<Enquire />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </ReviewGate>
  );
}

function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  return (
    <>
      <VisitTracker />
      {isAdmin ? (
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/*" element={<Admin />} />
        </Routes>
      ) : (
        <PublicShell />
      )}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: 'var(--tdt-ink)',
            color: 'var(--tdt-ivory)',
            border: '1px solid rgba(185,146,75,0.4)',
            borderRadius: '4px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.85rem',
            letterSpacing: '0.02em',
          },
        }}
      />
    </BrowserRouter>
  );
}
